import { products } from "@/data/products";

export const faqs: { q: string; a: string }[] = [
  {
    q: "What does Bane Tech do?",
    a: "Bane Tech builds and operates high-performance enterprise platforms for integration, live monitoring, enterprise architecture and integration delivery management.",
  },
  {
    q: "Which products does Bane Tech offer?",
    a: `Bane Tech offers ${products.map((p) => `${p.name} (${p.tagline})`).join(", ")}.`,
  },
  {
    q: "Can FireFly run on-premises and in the cloud?",
    a: "Yes. FireFly uses lightweight Docker-based deployment for flexible use across on-premises and cloud environments.",
  },
  {
    q: "Where is Bane Tech based?",
    a: "Bane Tech is based in Parque das Nações, Lisbon, Portugal, and works with clients worldwide.",
  },
  {
    q: "How can I request a demo or talk to the team?",
    a: "Use the contact form on this page and select the product you are interested in. The team will get back to you.",
  },
];

export const faqJsonLd = {
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
};

export const FAQ = () => (
  <section id="faq" className="py-20 md:py-24">
    <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }} />
    <div className="container max-w-3xl">
      <p className="font-mono text-xs uppercase tracking-widest text-primary">FAQ</p>
      <h2 className="mt-3 font-display text-3xl md:text-4xl font-bold tracking-tight">Frequently asked questions</h2>
      <div className="mt-10 divide-y divide-border rounded-2xl border border-border bg-card">
        {faqs.map((f) => (
          <details key={f.q} className="group p-5">
            <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-medium text-foreground">
              {f.q}
              <span className="text-primary transition-transform group-open:rotate-45 text-xl leading-none" aria-hidden>+</span>
            </summary>
            <p className="mt-3 text-muted-foreground leading-relaxed">{f.a}</p>
          </details>
        ))}
      </div>
    </div>
  </section>
);
